module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Life Group"},"fr":{"title":"Vie collectif"}}')
  delete Component.options._Ctor
}
